
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import {
  IDocumentReferable,
  DocumentSummary,
  DocumentSummaryHistory,
} from "../../../domain/document";
import { DeveloperPresentableMixin } from "../../developer/mixins";
import { default as SpecifiedDocumentHandleableMixin } from "./SpecifiedDocumentHandleableMixin.vue";

@Component
export default class DocumentViewBaseMixin extends Mixins(SpecifiedDocumentHandleableMixin, DeveloperPresentableMixin) {
  @Prop({ default: false })
  isEmbedded: boolean;

  @Prop()
  isMenuEnable: boolean;

  @Prop()
  isQuotable: boolean;

  @Prop({ default: false })
  shouldNotifyRegistered: boolean;

  @Prop({ default: false })
  isTemporary: boolean;

  @Prop()
  notification: string;

  data(): any {
    return {
      document: null as IDocumentReferable,
    };
  }
  document: IDocumentReferable;

  get isLoaded(): boolean {
    return !!this.document;
  }

  mounted(): void {
    if (this.shouldNotifyRegistered) {
      const action = this.isTemporary ? "一時保存" : "登録";
      const additionalMessage = this.isTemporary ? this.$configuration.behavior.document.editor.notifications.registerAsTemporary.message : "";
      this.$successAsHTML(
        action + "完了",
        "<div>文書を" + action + "しました。</div><div>" + additionalMessage + "</div>"
      );
    }
    if (this.notification) {
      this.$error("確認", this.notification);
    }
  }

  get isVirtual(): boolean {
    return (this.document instanceof DocumentSummary || this.document instanceof DocumentSummaryHistory)
      && this.document.isVirtual;
  }

  public async showVirtualDocumentAlert(): Promise<void> {
    const messages = ["仮想文書です。", "参照することが出来ません。"];
    await this.$commonDialogs.confirmation.show({
      title: "参照不可",
      message: messages,
      buttons: [],
      cancellation: {
        isEnable: true,
        label: "閉じる"
      },
    });
  }

  @Watch("isVirtual")
  async onIsVirtualUpdated(newValue: boolean): Promise<void> {
    if (newValue && !this.isDeveloperMode) {
      await this.showVirtualDocumentAlert();
      this.$closeWindow(true);
    }
  }
}
